// extracted by mini-css-extract-plugin
export default {"CleanSearch":"CleanSearch_CleanSearch__+ZaG0","CleanSearchText":"CleanSearch_CleanSearchText__02iN-","Icon":"CleanSearch_Icon__f4ype","cleanSearch":"CleanSearch_cleanSearch__wmomU"};